var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"made-by-component"},[_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_vm._v("©"+_vm._s(_vm.getDateYearActual())+" - FábricaInfo")])])
}
var staticRenderFns = []

export { render, staticRenderFns }